import { apiClient } from './client';

export interface Environment {
  key: string;
  name: string;
  description: string;
  order: number;
}

export interface Project {
  projectId: string;
  name: string;
  apiKey: string;
  environments: Environment[];
  createdAt: string;
}

export const projectsApi = {
  list: () => apiClient.get<Project[]>('/projects').then(r => r.data),
  create: (name: string) => apiClient.post<Project>('/projects', { name }).then(r => r.data),
  delete: (projectId: string) => apiClient.delete(`/projects/${projectId}`),
  getEnvironments: (projectId: string) =>
    apiClient.get<Environment[]>(`/projects/${projectId}/environments`).then(r => r.data),
  createEnvironment: (projectId: string, env: Omit<Environment, 'order'>) =>
    apiClient.post<Environment>(`/projects/${projectId}/environments`, env).then(r => r.data),
  updateEnvironment: (projectId: string, envKey: string, env: Partial<Environment>) =>
    apiClient.put<Environment>(`/projects/${projectId}/environments/${envKey}`, env).then(r => r.data),
  deleteEnvironment: (projectId: string, envKey: string) =>
    apiClient.delete(`/projects/${projectId}/environments/${envKey}`),
};
